"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customElementInit = void 0;
var _array = require("../../utils/type-checks/array");
var _function = require("../../utils/type-checks/function");
var _object = require("../../utils/type-checks/object");
var _string = require("../../utils/type-checks/string");
const customElementInit = elementMap => {
  const result = [];
  if ((0, _array.isArrayOfLength)(elementMap)) {
    elementMap.forEach(obj => {
      if ((0, _object.isObject)(obj) && (0, _string.isStringOfLength)(obj.name)) {
        const resultObject = {
          name: obj.name,
          value: false
        };
        if (!customElements.get(obj.name) && (0, _function.isFunction)(obj.component) && (0, _function.isFunction)(obj.customElement)) {
          obj.customElement.prototype.component = obj.component;
          customElements.define(obj.name, obj.customElement);
          resultObject.value = true;
        }
        result.push(resultObject);
      }
    });
  }
  return result;
};
exports.customElementInit = customElementInit;